// src/store/useAccountStore.ts
import { create } from "zustand";
/**
 * useAccountStore
 *
 * استور Zustand برای مدیریت داده‌های حساب کاربری.
 * این استور موجودی نقدی، موجودی اعتباری و کارت‌های کاربر را نگهداری می‌کند.
 *
 * ویژگی‌ها:
 * - balance: موجودی نقدی کاربر
 * - credit: اطلاعات اعتباری شامل موجودی، تاریخ انقضا، مقدار و بدهی کل
 * - cards: آرایه‌ای از کارت‌های کاربر
 * - setAccountData: تابعی برای بروزرسانی داده‌های حساب کاربری
 *
 * نمونه استفاده:
 * const { balance, credit, cards, setAccountData } = useAccountStore();
 *
 * جزئیات فیلدها:
 * - balance: موجودی نقدی کاربر (عدد)
 * - credit:
 *    - balance: موجودی اعتباری
 *    - expire: تاریخ انقضا اعتبار
 *    - amount: مقدار اعتبار
 *    - totalDebt: کل بدهی
 * - cards: آرایه کارت‌ها که هر کارت شامل:
 *    - id: شناسه کارت
 *    - user: شناسه کاربر
 *    - number: شماره کارت
 *    - cvv: کد امنیتی کارت
 *    - expire: تاریخ انقضا کارت
 *    - password: رمز کارت یا null
 *    - ts: زمان ایجاد کارت
 *    - updated_at: زمان آخرین بروزرسانی
 * - setAccountData(data): بروزرسانی کامل موجودی، اعتبارات و کارت‌ها
 */

interface Credit {
  balance: number;
  expire: number;
  amount: number;
  totalDebt: number;
}

interface Card {
  id: number;
  user: number;
  number: number;
  cvv: number;
  expire: string;
  password: string | null;
  ts: number;
  updated_at: number;
}

interface AccountState {
  balance: number;
  credit: Credit | null;
  cards: Card[];
  setAccountData: (data: {
    balance: number;
    credit: Credit;
    cards: Card[];
  }) => void;
}

const useAccountStore = create<AccountState>((set) => ({
  balance: 0,
  credit: null,
  cards: [],
  setAccountData: (data) =>
    set({
      balance: data.balance,
      credit: data.credit,
      cards: data.cards,
    }),
}));

export default useAccountStore;
